import { createSlice } from '@reduxjs/toolkit';
import { getVisibleColumns } from '../../../../services/ObjectConfiguration/ObjectConfiguration.service';
import { LoadingStatus, SortDirection } from '../../../../utils/constants';
// import { updateStartDate, updateEndDate } from '../../../../utils/dateTimeUtls';

export const filterFields = {
  ContractList: 'ContractList',
  BunkeringStartDate: 'BunkeringStartDate',
  BunkeringEndDate: 'BunkeringEndDate',
  client: 'client',
  productGrade: 'productGrade',
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
};

const applySaveFilterHandler = (state, action) => {
  const { fields, section } = action.payload;
  if (!Array.isArray(fields) || fields.length === 0) {
    return;
  }

  const fieldObj = {};
  fields.forEach(({ Field, Value, Text }) => {
    fieldObj[Field] = Value;
    if (Text) {
      fieldObj[`${Field}_Text`] = Text;
    }
  });

  [
    filterFields.BunkeringEndDate,
    filterFields.BunkeringStartDate,
    filterFields.ContractList,
    filterFields.client,
    filterFields.productGrade,
    filterFields.dateFrom,
    filterFields.dateTo,
  ].forEach((fieldName) => {
    const fieldValue = fieldObj[fieldName];
    state.filter[section][fieldName] = fieldValue || '';
  });
};

const initialFilterState = {
  Export_ExportFilter: {
    client: null,
    productGrade: null,
    dateFrom: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString(),
    dateTo: new Date().toISOString(),
  },
  Export_BunkerResults: {
    ContractList: [],
    BunkeringStartDate: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString(),
    BunkeringEndDate: new Date().toISOString(),
  },
  Export_FuelSystemsReport: {
    ContractList: [],
    BunkeringStartDate: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString(),
    BunkeringEndDate: new Date().toISOString(),
  },
  Export_ContractDetails: {
    ContractList: [],
  },
};
const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'ClientName',
  sortDirection: SortDirection.Desc,
};
const initialState = {
  filter: initialFilterState,
  tableInfo: initialPageState,
  tableItems: [],
  totalItemCount: 0,
  loadingStatus: LoadingStatus.Idle, // idle, pending, success, failed

  page: 1,
  sort: null,

  isFilterVisible: true,

  visibleGridColumns: [],
  mergedColumns: [],
  loadingGridColumnStatus: LoadingStatus.Idle,

  isSavedFilterLoaded: false,
  savedFilterList: [],
  isSavedFilterLoadedForBunker: false,
  savedFilterListForBunker: [],
  isSavedFilterLoadedForFuel: false,
  savedFilterListForFuel: [],
  isSavedFilterLoadedForContract: false,
  savedFilterListForContract: [],
};

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {
    showHideFilter(state, action) {
      state.isFilterVisible = action.payload;
    },
    updateFilterValue(state, action) {
      const { propName, propValue, section } = action.payload;
      state.filter[section][propName] = propValue;
    },
    resetSearchFilter(state, action) {
      const section = action.payload || {};
      if (section) {
        state.filter[section] = { ...initialFilterState[section] };
      }
    },
    resetSearchFiltersAndPagination(state, action) {
      state.filter = { ...initialFilterState, ...action.payload };
      state.tableInfo = { ...initialPageState };
    },
    updatePageInfoField(state, action) {
      const { propName, propValue } = action.payload;
      state.tableInfo[propName] = propValue;
    },
    setPage(state, action) {
      state.tableInfo.page = action.payload;
    },
    updateLoadingStatus(state, action) {
      state.loadingStatus = action.payload;
    },
    searchExport(state, action) {
      state.tableItems = action.payload.items;
      state.totalItemCount = action.payload.totalItemCount;
    },
    // Start - Grid Columns Setting Actions
    updateUserColumnSettings(state, action) {
      state.mergedColumns = action.payload;
      state.visibleGridColumns = getVisibleColumns(action.payload);
    },

    updateLoadingColumnSettingStatus(state, action) {
      state.loadingGridColumnStatus = action.payload;
    },

    updateVisibleGridColumns(state, action) {
      state.visibleGridColumns = action.payload;
    },
    updateMergedGridColumns(state, action) {
      state.mergedColumns = action.payload;
    },
    // End - Grid Columns Setting

    updateSavedFilterList(state, action) {
      state.isSavedFilterLoaded = true;
      state.savedFilterList = action.payload;
    },
    updateSavedFilterListForBunker(state, action) {
      state.isSavedFilterLoadedForBunker = true;
      state.savedFilterListForBunker = action.payload;
    },
    updateSavedFilterListForFuel(state, action) {
      state.isSavedFilterLoadedForFuel = true;
      state.savedFilterListForFuel = action.payload;
    },
    updateSavedFilterListForContract(state, action) {
      state.isSavedFilterLoadedForContract = true;
      state.savedFilterListForContract = action.payload;
    },

    applySavedFilter(state, action) {
      applySaveFilterHandler(state, action);
    },
    updatingSorting(state, action) {
      const { sortBy, sortOrder } = action.payload;
      state.tableInfo['sortColumn'] = sortBy;
      state.tableInfo['sortDirection'] = sortOrder;
    },
  },
});

export const tableInfoFields = {
  page: 'page',
  pageSize: 'pageSize',
  sortColumn: 'sortColumn',
  sortDirection: 'sortDirection',
};

export const exportActions = exportSlice.actions;
export default exportSlice.reducer;
